import { logService } from '@/services/log-service'
import { localStorageService, sessionStorageService } from '@/services/storage-service'

import authService from '../core/authService'
import { PAGES } from '../routes/pages'

let redirectToLoginTimeoutId

export const redirectToLoginTimerClear = () => {
  if (redirectToLoginTimeoutId) {
    window.clearTimeout(redirectToLoginTimeoutId)
    redirectToLoginTimeoutId = undefined
  }
}

export const redirectToLoginTimerStart = (history) => {
  try {
    redirectToLoginTimerClear()
    const millisecondsTillExpiration = authService.getMillisecondsTillExpiration()
    redirectToLoginTimeoutId = window.setTimeout(() => {
      // read at fire time: the user has navigated since the timer started
      const locationPath = `${window.location.pathname}${window.location.search}`
      logService.info('Redirecting to login', { prevLocation: locationPath })
      localStorageService.removeJwtToken()
      sessionStorageService.removeJwtToken()
      history.push(PAGES.brandsLogin.path, { prevLocation: locationPath })
    }, millisecondsTillExpiration)
  } catch (error) {
    logService.error('Error redirecting to login', { error })
    return undefined
  }
}
